import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { adoptSessionFromOpenTab, listenForOtherTabs } from './utils/session';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// The store reads the session when it is created, so a new tab first collects the session from any HRMS tab
// still open (see utils/session); the store and App are only loaded after that.
adoptSessionFromOpenTab().then(async () => {
  listenForOtherTabs();
  const [{ store }, { default: App }] = await Promise.all([import('./store/store'), import('./App')]);
  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <App />
      </Provider>
    </React.StrictMode>
  );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Installable PWA: register the pass-through service worker (it caches nothing). Production only,
// so the dev server's hot reload is never intercepted.
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register(`${process.env.PUBLIC_URL}/sw.js`).catch(() => {
      // Installability is a nice-to-have; never let it break the app.
    });
  });
}
